<div>
    @if (shownExposures().length !== 0) {
    <div class="column-left">
        <div class="header">
            <div class="checkbox-icon" [ngClass]="{ selected: onlyShowAffected() }" (click)="showAffectedToggle()"></div>
            <div>Vis kun eksponerte</div>
        </div>
        <div class="total-risk-score">
            <div>Risikoscore total</div>
            <div class="physical-exposure-risk-score" (click)="toggleTotalRiskScoreTooltip()" (clickOutside)="closeTotalRiskScoreTooltip()">
                {{ data()?.totalPhysicalRiskScore }}

                <ev_tooltip [visible]="totalRiskScoreTooltipOpen" [top]="-150" [arrowTopAlign]="140" [arrowAlignRight]="8" [right]="1" [arrow]="'bottom'">
                    Total fysisk risikoscore for denne eiendommen er {{ data()?.totalPhysicalRiskScore }} av 6, der 6 er høyest risiko. Total fysisk risikoscore
                    settes lik den høyeste risikoscoren for de underliggende fysisk risiko scenariene.
                </ev_tooltip>
            </div>
        </div>
    </div>
    } @if (shownExposures().length === 0 && onlyShowAffected()) {
    <div class="not-found">
        <div class="info-icon"></div>
        Ingen eksponerte risikoscenarioer funnet for denne eiendommen
    </div>
    } @else if (shownExposures().length !== 0) {
    <div class="units-wrapper">
        <ev-grid-table [gridModel]="displayTemplate">
            <ev-th>
                <!-- <ev-td class="spacing-left" area="spacingLeft"></ev-td> -->

                @for(column of headers; track column.name) { @if(column?.isSortable) {
                <ev-td
                    [area]="column.prop"
                    (click)="updateSort(column.prop)"
                    [isSelectable]="true"
                    [textAlignment]="column.textAlignment ?? 'left'"
                    [selected]="sortConfig().sortOption.prop == column.prop"
                >
                    {{ column.name.toUpperCase() }}
                </ev-td>
                } @else {
                <ev-td [area]="column.prop" [textAlignment]="column.textAlignment ?? 'left'">
                    {{ column.name.toUpperCase() }}
                </ev-td>
                } }
            </ev-th>
            @if (tableData()) { @for(rowData of tableData(); track $index) {
            <ev-tr class="ev-row" [hasRowContent]="false">
                <ev-td area="exposureCategoryName" header="Type" column title="Type">
                    <div class="column-data">{{ rowData.exposureCategoryName }}</div>
                </ev-td>
                <ev-td
                    area="exposureScenarioName"
                    header="Scenario"
                    column
                    title="Scenario"
                    textAlignment="left"
                    [fontBold]="sortConfig().sortOption.prop == 'exposureScenarioName'"
                >
                    <div class="column-data">{{ rowData.exposureScenarioName }}</div>
                </ev-td>
                <ev-td
                    area="exposureTypeLevel"
                    header="Nivå"
                    column
                    title="Nivå"
                    [fontBold]="sortConfig().sortOption.prop == 'exposureTypeLevel'"
                    textAlignment="left"
                >
                    <div class="column-data">{{ rowData.exposureTypeLevel }}</div>
                </ev-td>
                <ev-td
                    area="exposureImpactName"
                    header="Berørt"
                    column
                    title="Berørt"
                    textAlignment="left"
                    [fontBold]="sortConfig().sortOption.prop == 'exposureImpactName'"
                >
                    <div class="column-data">{{ rowData.exposureImpactName }}</div>
                </ev-td>
                <ev-td
                    area="exposureRiskScore"
                    header="Risikoscore"
                    column
                    title="Risikoscore"
                    textAlignment="right"
                    [fontBold]="sortConfig().sortOption.prop == 'exposureRiskScore'"
                >
                    @if(rowData.exposureRiskScore > 0) {
                    <div class="column-data physical-exposure-risk-score">{{ rowData.exposureRiskScore }}</div>
                    }
                </ev-td>
            </ev-tr>
            } }
        </ev-grid-table>
    </div>

    @if(originalData()?.length > rowsToShow) {
    <div class="show-more-button">
        <button (click)="onShowMore()">Vis flere</button>
    </div>
    } }
</div>
